import { render, staticRenderFns } from "./VueVis.vue?vue&type=template&id=b94fe306"
import script from "./VueVis.vue?vue&type=script&lang=js"
export * from "./VueVis.vue?vue&type=script&lang=js"
import style0 from "./VueVis.vue?vue&type=style&index=0&id=b94fe306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports